import React from 'react';
import PageContainer from 'components/layout/PageContainer';

const HomePage = () => (
  <PageContainer
    breadcrumbs={[
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      { id: 1, name: 'INICIO'},
    ]}
  >
    <div />
  </PageContainer>
);

export default HomePage;
